import { useState, useEffect } from "react"
import { faEdit, faTrashCan } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from "classnames"
import { useNavigate } from "react-router-dom"

import { formatUrl } from "../../helpers/parse-url"
import { parseTime } from "../../helpers/parse-time"
import { serverUrl } from "../../services/configs/server"
import { useAuth } from "../../services/authentication/authentication.context"
import { AppAlert } from "../utilities/alert"
import { Loader } from "../utilities/loader"
import { SearchBar } from "../forms/search-box"
import { categories } from "../../helpers/mock-data"
import { deleteTutorial, getTutorialsByField } from "../../services/documents/documents.context"

export const Questionsdata = () => {

    const [dataAction, setDataAction] = useState(null);
    const [dataId, setDataId] = useState();
    const [uniData, setUnitData] = useState(null);
    const [isAlert, setIsAlert] = useState();
    const [categ, setCateg] = useState('Nursing');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigateTo = useNavigate();

    const { token } = useAuth();

    useEffect(() => {
        (async () => {
            /** all HND Past questions */
            const allTutorials = await getTutorialsByField(categ);
            setData(allTutorials);
        })();
    }, [categ])

    return (
        <div className="data-container">
            <div className="titles-box">
                <div className={classNames("user-info", "caps")}>Category</div>
                <div className={classNames("user-title", "caps")}>Title</div>
                <div className={classNames("user-role", "caps")}>Since</div>
                <div className={classNames("modify", "caps")}>Edit/Delete</div>
            </div>
            <div className="flx-c flx-v">
                <SearchBar
                    selectKey={(v) => {
                        setCateg(v)
                    }}
                    categories={categories}
                    defVal={'Nursing'}
                    incAll={false}
                />
            </div>
            <div className="info-details">
                {data?.map((d, indx) => {
                    return (
                        <div
                            className={classNames("info-box", { "even": indx % 2 === 0 })}
                            key={indx}
                        >
                            {isAlert && (
                                <AppAlert
                                    message={isAlert.message}
                                    caption={isAlert.caption}
                                    accept={"Delete"}
                                    reject={"Cancel"}
                                    acceptAction={() => {
                                        setIsAlert();
                                        isAlert.alertMethod();
                                    }}
                                    rejectAction={() => setIsAlert()}
                                />
                            )}
                            <div className="data-box">
                                <div className={classNames("user-info", "info-data")}>

                                    {'Tutorial'}
                                </div>
                                <div className={classNames("user-title", "info-data")}>
                                    {d?.title || "Not given"}
                                </div>
                                <div className={classNames("user-role", "info-data")}>
                                    <span className="role-data">{parseTime(d?.createdAt)}</span>
                                </div>
                                <div className={classNames("modify", "info-data")}>
                                    <button
                                        className="mod-button"
                                        onClick={() => {
                                            setDataAction("edit");
                                            setDataId(d?._id);
                                            setUnitData(d);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEdit} className="mod-icon" />
                                    </button>
                                    <button
                                        className="mod-button"
                                        onClick={() => {
                                            setDataAction("delete");
                                            setDataId(d?._id);
                                            setUnitData(d);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} className="mod-icon" />
                                    </button>
                                </div>
                            </div>
                            {(dataAction === "delete" && dataId === d?._id) &&
                                <div className="del-section">
                                    <span className="warning-msg">
                                        {`Do you want to delete this document? 
                                                  This action is irreversible!`
                                        }
                                    </span>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => setIsAlert({
                                            caption: "Delete document",
                                            message: "Do you wish to delete this document?",
                                            alertMethod: async () => {
                                                setLoading(true);
                                                const resp = await deleteTutorial(d?._id, d?.pdfFile, token);
                                                if (resp?.error) {
                                                    return alert(resp?.error);
                                                }
                                                if (resp?.message) {
                                                    setLoading(false);
                                                    alert(resp.message);
                                                    window.location.reload();
                                                }
                                            }
                                        })}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => {
                                            setDataAction(null);
                                            setDataId(null);
                                            setUnitData(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            }

                            {(dataAction === "edit" && dataId === d?._id) &&
                                <div className="edit-section">
                                    <span className="edit-msg">
                                        {`Update this document?`}
                                    </span>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => navigateTo("/update_publication", { state: { publication: d } })}
                                    >
                                        Update
                                    </button>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => {
                                            setDataAction(null);
                                            setDataId(null);
                                            setUnitData(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    )
}